import script from "./addRateMix.vue?vue&type=script&setup=true&lang=js"
export * from "./addRateMix.vue?vue&type=script&setup=true&lang=js"

import "./addRateMix.vue?vue&type=style&index=0&id=1c484f83&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c484f83"]])

export default __exports__